import { useSelector } from "react-redux";
import { useRef, useState } from "react";
import ApplyCredit from "./ApplyCredit";
import Accountprice from "../../../utils/Accountprice";
const CreditSection = ({ tableData,applycredit,orderid }) => {
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [vouchererror, setvouchererror] = useState("");
  const closeref = useRef(null);
  const openalert = useRef(null);






  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "0px 6px",
        marginBottom: "8px",
      }}
    >


      <div
        className="newscrollerbar"
        style={{ width: "100%", marginTop: '10px', paddingTop: '5px' }}
      >
        <table
          className="table-responsive bg-white mt-3"
          style={{ width: "100%" }}
        >
          <tbody>
            <>
              <tr style={{ borderBottom: '1px solid black' }}>

                <th
                  style={{
                    textWrap: "nowrap",
                    fontSize: "12px",
                    width: "33%",
                    padding: '5px 4px'
                  }}
                >
                  Available Credits
                </th>
                <th
                  style={{
                    textWrap: "nowrap",
                    fontSize: "12px",
                    width: "33%",
                    padding: '5px 4px'
                  }}
                  className="px-lg-0 px-2"
                >
                  GST
                </th>
                <th
                  style={{
                    textWrap: "nowrap",
                    fontSize: "12px",
                    width: "33%",
                    padding: '5px 4px'
                  }}
                  className="px-lg-0 px-2"
                >
                  Shipping
                </th>

                <th></th>
              </tr>


              <tr>

                <td style={{ fontSize: "12px", position: 'relative', left: '4px' }}>
                  {Accountprice(tableData.total)}


                </td>

                <td style={{ fontSize: "12px" }}>
                  {tableData.gst == false ? "Payable" : "Inclusive"}
                </td>
                <td style={{ fontSize: "12px" }}>
                  {tableData.shipping == false ? "Payable" : "Inclusive"}

                </td>

              </tr>

            </>
          </tbody>
        </table>
      </div>


      <table className="table bg-white mt-3">
        <tbody>
          <tr className="" style={{ borderBottom: '1px solid #fff' }}>
            <td
              style={{
                fontWeight: "700",
                display: "flex",
                gap: "19px",
                alignItems: "center",
                flexWrap: "wrap",
              }}
              className="titlesizes"
            >
              <span >

                <span>

                  Redeem Credits
                </span>

              </span>
              <div style={{ display: "flex", gap: 4 }}>

                <button
                  className="btn"
                  style={{
                    fontWeight: 500,
                    border: "1px solid #c1c1c1",
                    color: "black",
                    borderRadius: "0px",
                    fontSize: 12,
                    height: "fit-content",
                    padding: "7px 8px",
                  }}

                >
                  {tableData.AllowCredit}

                </button>
              </div>
              <ApplyCredit ship={tableData.shipAmount} applycredit={applycredit} orderid={orderid} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default CreditSection